export class MoreAboutTemplate {
  enterprisePartnerName: string;
  enterpriseName: string;
  base64: any;
  parameters: any;
}
